import { requireKarelCodeText } from "./assets";
import { starterCodeCandidates, type StarterLanguage } from "./starterCode";

/**
 * Resolves the starter code for a lesson in the requested language from the
 * build-time bundle, trying each candidate key in order. The lesson supplies a
 * base name such as `u3l6.starter`; the active language selects the extension.
 *
 * Separate from `starterCode.ts` so that the pure candidate helper stays
 * importable outside Vite (e.g. by the unit-test runner).
 */
export async function fetchStarterCode(
  starterCode: string,
  language: StarterLanguage,
): Promise<string> {
  const candidates = starterCodeCandidates(starterCode, language);
  let lastError: unknown;
  for (const path of candidates) {
    try {
      return requireKarelCodeText(path);
    } catch (error) {
      lastError = error;
    }
  }
  throw lastError instanceof Error
    ? lastError
    : new Error(`No starter code found for ${starterCode}`);
}
